const StatItem = ({ label, value }) => (
  <div className="stat-item">
    <span className="stat-label">{label}</span>
    <span className="stat-value">{value}</span>
  </div>
);

const WeatherCard = ({ data }) => {
  const { city, temp, description, icon, feelsLike, humidity, pressure, wind, clouds } = data;
  const iconUrl = `https://openweathermap.org/img/wn/${icon}@2x.png`;

  return (
    <div className="weather-grid">
      <div className="hero-card">
        <div className="hero-content">
          <p className="eyebrow">Live Weather</p>
          <h2 className="city">{city}</h2>
          <p className="description">{description}</p>
          <div className="temp-row">
            <div className="temp">
              {temp}
              <span className="degree">°C</span>
            </div>
            <div className="icon-badge">
              <img src={iconUrl} alt={description || 'weather icon'} />
              <span className="badge-label">Feels like {feelsLike}°C</span>
            </div>
          </div>
        </div>
      </div>

      <div className="details-card">
        <p className="eyebrow">Atmospheric Snapshot</p>
        <div className="stat-grid">
          <StatItem label="Humidity" value={`${humidity}%`} />
          <StatItem label="Wind" value={`${wind} m/s`} />
          <StatItem label="Pressure" value={`${pressure} hPa`} />
          <StatItem label="Cloud Cover" value={`${clouds}%`} />
        </div>
      </div>
    </div>
  );
};

export default WeatherCard;
